import React, { createContext, useState, useContext, useEffect } from 'react';
import { getUser } from '../Services/authService';
// Create the context
const LoginPermissionContext = createContext();

// Create a provider component
export const LoginPermissionProvider = ({ children }) => {
    const [globalLoginPermission, setGlobalLoginPermission] = useState({
        isAdmin: false,
        isBranchAdmin: false,
        isRestricted: false,
    });

    const fetchUserData = async () => {
        const token = localStorage.getItem('enduser');
        if (token) {
            try {
                const userData = await getUser();
                if(userData){
                    setGlobalLoginPermission(prevState => ({
                        ...prevState,
                        isAdmin: userData.data.isAdmin,
                        isBranchAdmin: userData.data.isBranchAdmin,
                        isRestricted: userData.data.isRestricted
                    }));
                }

            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        }

    };
    useEffect(() => {
        fetchUserData();
    }, []);

    return (
        <LoginPermissionContext.Provider value={{ globalLoginPermission, setGlobalLoginPermission, fetchUserData }}>
            {children}
        </LoginPermissionContext.Provider>
    );
};

// Custom hook to use the OpportunityContext
export const useLoginPermissionProvider = () => {
    return useContext(LoginPermissionContext);
};
